import * as analytics from '@gitbook/app-analytics/client';
import { Button, Description, Heading } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import {
    TemplateCard,
    TemplateCardActions,
    TemplateCardFooter,
    TemplateCardImage,
    TemplateCardPreview,
} from '../../Templates';
import type { SpaceCreationOnCreateSpace } from './types';

export interface BlankTemplateCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function BlankTemplateCard(props: BlankTemplateCardProps) {
    const { organizationId, onCreateSpace } = props;

    return (
        <TemplateCard>
            <TemplateCardPreview>
                <TemplateCardImage
                    src={{
                        light: 'https://gitbookio.github.io/onboarding-template-images/templates/blank.png',
                        dark: 'https://gitbookio.github.io/onboarding-template-images/templates/blank-dark.png',
                    }}
                />
                <TemplateCardActions>
                    <Button
                        label="Start with blank"
                        onPress={async () => {
                            await onCreateSpace(async ({ collectionId }) => {
                                const { data: space } = await apiClient.spaces.createSpace(
                                    organizationId,
                                    { parent: collectionId }
                                );
                                analytics.logEvent(
                                    analytics.createSpaceEvent(space, {
                                        type: 'space_create',
                                        source: 'blank',
                                    })
                                );
                                return space;
                            });
                        }}
                    />
                </TemplateCardActions>
            </TemplateCardPreview>
            <TemplateCardFooter>
                <div className="flex flex-col gap-1">
                    <Heading>Blank</Heading>
                    <Description>An empty space to start from scratch.</Description>
                </div>
            </TemplateCardFooter>
        </TemplateCard>
    );
}
